export default "__VITE_ASSET__$bz3E0Uv__"